import { useMemo } from 'react';
import { generatePath, useParams } from 'react-router-dom';
import { pipe, Option } from 'effect';
import { accessInputToOption } from '@/abilities/accessInput';
import { useCompanyBankFeedAccess } from '@/abilities/companyBankFeed/useCompanyBankFeedAccess';
import ROUTES_PATH from '@/router/routesPathConfig';
import { companySettingsDestinationRoutes } from '@/pages/configurations/company/destinationRoutes';

/** The address of Bank Feed's connections in settings, for the page's shortcuts; none until the user is known to
 *  be allowed to open them. */
export const useBankFeedConnectionSettingsLink = (): Option.Option<string> => {
  const access = useCompanyBankFeedAccess();
  const { companyId } = useParams();
  return useMemo(
    () =>
      pipe(
        accessInputToOption(access),
        Option.filter(({ settingsAccessOf }) => settingsAccessOf('bankFeed.connections') === 'open'),
        Option.map(() =>
          generatePath(ROUTES_PATH[companySettingsDestinationRoutes['bankFeed.connections']].absolute, { companyId }),
        ),
      ),
    [access, companyId],
  );
};
